import angular from "angular";

angular.module("ticketco/common").factory("tcDialogWrapper", tcDialogWrapper);

function tcDialogWrapper($q, ngDialog) {
  function validateDialogResponse(response) {
    if (typeof response.value === "string" || response.value === undefined)
      return $q.reject({ reason: "close" });
    return response.value;
  }

  function open(config) {
    if (config === undefined) throw new TypeError("Config can't be blank!");
    if (Object.prototype.toString.call(config) !== "[object Object]")
      throw new TypeError("Config should be an Object!");
    if (config.name === undefined)
      console.warn(
        "You open dialog without name. Name is used to avoid duplicates."
      );
    var mDialog = ngDialog.open(config);

    if (mDialog) {
      return mDialog.closePromise.then(validateDialogResponse);
    } else {
      return $q.reject();
    }
  }

  return {
    open: open,
  };
}
